(function () {
  var header = document.getElementById("HeaderWrapper");
  var bodyy = document.querySelector("body");
  if (header && bodyy) {
    window.addEventListener("scroll", function () {
      if (window.scrollY > 170) {
        header.classList.add("Sifat__stuck");
        bodyy.classList.add("Sifat__stuck");
      } else {
        header.classList.remove("Sifat__stuck");
        bodyy.classList.remove("Sifat__stuck");
      }
    });
  }
})();

/**
 * PartFinder vehicle filtering — KEEP when it works.
 * When a vehicle-filtered collection has 0 verified matches: do NOT show the
 * full catalog as if those products fit. Show a clear no-match message + a
 * voluntary link to browse the brand unfiltered.
 */
(function () {
  var VEHICLE_PATH =
    /^(\/collections\/[^\/]+)\/([A-Za-z][A-Za-z0-9]*(?:-[A-Za-z0-9]+)*-\d{4})\/?$/;

  function vehicleLabel(slug) {
    return (slug || "").replace(/-/g, " ");
  }

  function collectionIsEmpty() {
    var text = (document.body && document.body.innerText) || "";
    var lower = text.toLowerCase();
    return (
      /\b0\s+products?\b/i.test(text) ||
      lower.indexOf("no products") !== -1 ||
      lower.indexOf("doesn't have any products") !== -1 ||
      lower.indexOf("does not have any products") !== -1
    );
  }

  function hideProductGrid() {
    var selectors = [
      ".collection-grid",
      ".product-grid",
      "#CollectionProductGrid",
      "[data-section-type='collection-template'] .grid",
      ".collection items",
      ".collection__products",
      "#main-collection-product-grid",
      ".product-list",
      ".collection-listing",
    ];
    selectors.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) {
        el.style.display = "none";
      });
    });
    document.querySelectorAll(".pagination").forEach(function (el) {
      el.style.display = "none";
    });
  }

  function showNoVerifiedMatch(slug, collectionPath) {
    if (document.getElementById("kova-fitment-no-match")) return;
    hideProductGrid();
    var bar = document.createElement("div");
    bar.id = "kova-fitment-no-match";
    bar.setAttribute("role", "status");
    bar.style.cssText =
      "background:#111;color:#fff;padding:28px 20px;text-align:center;font-size:15px;line-height:1.55;border-bottom:3px solid #e85d04;max-width:900px;margin:24px auto;";
    var label = vehicleLabel(slug);
    bar.innerHTML =
      "<p style=\"margin:0 0 10px;font-size:18px;font-weight:700;\">No verified fits for <span style=\"color:#e85d04;\">" +
      label +
      "</span></p>" +
      "<p style=\"margin:0 0 16px;opacity:.92;\">We do not have products in this brand that are confirmed for your selected vehicle. We are not showing the full catalog here so unverified items are not presented as fits.</p>" +
      "<p style=\"margin:0;\">" +
      '<a href="' +
      collectionPath +
      '" style="display:inline-block;background:#e85d04;color:#111;font-weight:700;padding:10px 16px;text-decoration:none;border-radius:4px;">Browse all products in this brand (unfiltered)</a>' +
      "</p>" +
      "<p style=\"margin:12px 0 0;font-size:13px;opacity:.8;\">Unfiltered browsing is not a fitment confirmation.</p>";
    var main =
      document.querySelector("main") ||
      document.querySelector("#MainContent") ||
      document.querySelector(".main-content") ||
      document.body;
    if (main.firstChild) main.insertBefore(bar, main.firstChild);
    else main.appendChild(bar);
  }

  function boot() {
    var path = location.pathname || "";
    var m = path.match(VEHICLE_PATH);
    var params;
    try {
      params = new URLSearchParams(location.search || "");
    } catch (e) {
      params = null;
    }

    // Legacy ?fitment_fallback=1 URLs used to dump the full catalog — stop that.
    if (params && params.get("fitment_fallback") === "1") {
      var vehicle = params.get("vehicle") || "your vehicle";
      var base =
        path.replace(/\/$/, "") ||
        (document.querySelector('link[rel="canonical"]') &&
          new URL(document.querySelector('link[rel="canonical"]').href).pathname) ||
        "/collections/all";
      // If we're already on the unfiltered collection with the old fallback flag,
      // replace with a clear no-match state instead of listing products as fits.
      showNoVerifiedMatch(vehicle, base.split("?")[0]);
      return;
    }

    if (!m) return;
    if (!collectionIsEmpty()) return;

    // Empty vehicle-filtered collection: clear message only (no full-catalog redirect).
    showNoVerifiedMatch(m[2], m[1]);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
